module.exports = __webpack_public_path__ + "img/logo.ca644a69.svg";